export const MoreIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    xmlns='http://www.w3.org/2000/svg'
    width='4.305'
    height='18.654'
    viewBox='0 0 4.305 18.654'
  >
    <circle cx='2.152' cy='2.152' r='2.152' />
    <circle cx='2.152' cy='2.152' r='2.152' transform='translate(0 7.174)' />
    <circle cx='2.152' cy='2.152' r='2.152' transform='translate(0 14.349)' />
  </svg>
)
